import * as React from 'react';

function SvgResidentTypeStudentOnlySelected(props) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 96" {...props}>
      <path
        d="M19 23a2 2 0 012-2h35a2 2 0 012 2v7a2 2 0 01-2 2H21a2 2 0 01-2-2v-7zM51 2a2 2 0 012-2h40a2 2 0 012 2v7a2 2 0 01-2 2H53a2 2 0 01-2-2V2zM22 68h36v7H22z"
        fill="#E4F2EE"
      />
      <path
        d="M32 62a2 2 0 012-2h12a2 2 0 012 2v13a2 2 0 01-2 2H34a2 2 0 01-2-2V62zm-13-7.5A9.5 9.5 0 019.5 64 9.5 9.5 0 010 54.5 9.5 9.5 0 019.5 45a9.5 9.5 0 019.5 9.5z"
        fill="#E4F2EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54 3v5h38V3H54zm-1 8h2v10H21a2 2 0 00-2 2v7a2 2 0 002 2h1v42H10.915c.055-.156.085-.325.085-.5v-9.618c4.534-.719 8-4.646 8-9.382a9.5 9.5 0 00-19 0c0 4.736 3.466 8.663 8 9.382V73.5c0 .175.03.344.085.5H2.5a1.5 1.5 0 000 3h61a1.5 1.5 0 000-3H58v-1h33V11h2a2 2 0 002-2V2a2 2 0 00-2-2H53a2 2 0 00-2 2v7a2 2 0 002 2zm-8 63H35V63h10v11zm3-12v12h7V32H25v42h7V62a2 2 0 012-2h12a2 2 0 012 2zm10 8h30V11H58v59zm-3-46H22v5h33v-5zM16 54.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm47-31a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zm-33 16a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zM44.5 38a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4zM76 23.5a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zM44.5 49a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4zM76 34.5a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zM31.5 49a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4zM63 34.5a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5z"
        fill="#38B2A6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43 66.5C43 82.792 56.208 96 72.5 96S102 82.792 102 66.5 88.792 37 72.5 37 43 50.208 43 66.5z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50 67.324c0 12.329 9.926 22.323 22.17 22.323 12.245 0 22.171-9.994 22.171-22.323 0-12.33-9.926-22.324-22.17-22.324C59.926 45 50 54.995 50 67.324z"
        fill="#E4F2EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.261 77.491l2.127.972c6.323-14.196.81-30.902-12.694-38.463l-1.127 2.035C98.02 49 103.101 64.407 97.262 77.49zM46 79.724C51.073 89.682 61.238 95.96 72.353 96a29.55 29.55 0 0012.103-2.64l-.95-2.146c-13.249 5.952-28.808.435-35.43-12.563L46 79.724z"
        fill="#FFA950"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.302 72.712a8.332 8.332 0 003.657-6.912c0-4.597-3.701-8.324-8.267-8.324-4.566 0-8.267 3.727-8.267 8.325a8.331 8.331 0 003.658 6.91c-2.985 1.302-5.39 3.823-6.77 6.94a1.5 1.5 0 002.743 1.214c1.643-3.712 4.953-6.116 8.636-6.116 3.684 0 6.993 2.404 8.636 6.116a1.5 1.5 0 002.743-1.214c-1.38-3.117-3.784-5.638-6.77-6.94zm.657-6.912c0 2.96-2.377 5.325-5.267 5.325-2.89 0-5.267-2.365-5.267-5.325s2.378-5.324 5.267-5.324c2.89 0 5.267 2.364 5.267 5.325z"
        fill="#38B2A6"
      />
      <path d="M60.074 58.79l12.618-3.942L85.31 58.79l-12.618 3.943-12.618-3.943z" fill="#E4F2EE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.14 53.416a1.5 1.5 0 00-.895 0l-12.619 3.943a1.5 1.5 0 000 2.863l.49.153a1.504 1.504 0 00-.042.354v7.515a1.5 1.5 0 103 0V61.3l9.17 2.865c.292.091.604.091.895 0l12.618-3.943a1.5 1.5 0 000-2.863L73.14 53.416zm-.448 7.746l-7.59-2.371 7.59-2.372 7.59 2.372-7.59 2.371z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgResidentTypeStudentOnlySelected;
